<template>
  <div class="auth-form-container">
    <el-input
      class="auth-input auth-form"
      placeholder="Buscar por nome…"
      v-model="input"
      prefix-icon="el-icon-search"></el-input>
    <span class="auth-qtd">Você possui {{qtd}} operadora<a v-if="qtd > 1">s</a> vinculada<a v-if="qtd > 1">s</a></span>
    <div class="auth-listagem">
      <ul class="infinite-list auth-list" style="overflow:auto" v-for="(operadora, index) in operadorasFiltradas"
          :key="index" @click="onSubmit(operadora)"> <!---passa a operadora como parametro -->
        <el-link :underline="false" class="auth-list-link">
          <img v-if="operadora.imagem" class="auth-img" :src="operadora.imagem"/>
          <img v-if="!operadora.imagem" class="auth-img" src="@/assets/img/avatar-empresa-default.png"/>
          <li class="infinite-list-item auth-nome">{{ operadora.nome }}</li>
          <i class="el-icon-arrow-right right-arrow"></i>
        </el-link>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'FormSelecionaOperadora',
  data () {
    return {
      title: 'Selecione a operadora',
      routerName: 'FormLogin',
      buttonBack: true,
      input: '',
      qtd: ''
    }
  },
  methods: {
    ...mapActions('login', [
      'validaLogin', 'selecionaOperadora'
    ]),
    onSubmit (operadora) {
      this.selecionaOperadora(operadora)
    }
  },
  computed: {
    ...mapState('login', [
      'contexto',
      'loading',
      'operadoras',
      'operadora'
    ]),

    operadorasFiltradas () {
      if (this.input !== ' ') {
        let exp = new RegExp(this.input.trim(), 'i')
        return this.operadoras.filter(operadora => exp.test(operadora.nome))
      } else {
        return this.operadoras
      }
    }
  },
  created () {
    this.$root.$emit('set-data-auth', {
      title: this.title,
      buttonBack: this.buttonBack,
      routerName: this.routerName
    })
    this.qtd = this.operadoras.length
  }
}
</script>
<style lang="sass" scoped>
  @import url('https://fonts.googleapis.com/css?family=Nunito&display=swap')
  @import '../../../views/auth/auth.scss'
</style>
